import {
  Box,
  createTheme,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
} from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useStyles } from "../../shared/styles/useStyles";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducers/rootReducer";
import { CustomizedTableFooter } from "../custom/CustomizedTableFooter";
import { EntitiesBody } from "./EntitiesBody";
import { useEffect, useState } from "react";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
    fontSize: 12,
  },
});

export const EntitiesTable = () => {
  const classes = useStyles();
  const { entities } = useSelector((state: AppState) => state.entities);
  const [count, setCount] = useState(0);
  // Paginación
  const { page, rowsPerPage } = useSelector((state: AppState) => state.pagination);

  useEffect(() => {
    // console.log(entities);

    setCount(entities.length);
  }, [entities, count, rowsPerPage]);
  return (
    <ThemeProvider theme={theme}>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-label="custom pagination table"
          style={{ tableLayout: "auto" }}
        >
          <TableHead>
            <TableRow>
              <TableCell className={classes.titleTable}>
                <FormattedMessage id="NameEntity" />{" "}
              </TableCell>
              <TableCell className={classes.titleTable}>
                <FormattedMessage id="EntityType" />{" "}
              </TableCell>
              <TableCell className={classes.titleTable}>
                <FormattedMessage id="Country" />{" "}
              </TableCell>
              <TableCell className={classes.titleTable}>
                <FormattedMessage id="Department" />{" "}
              </TableCell>
              <TableCell className={classes.titleTable}>
                <FormattedMessage id="Town" />{" "}
              </TableCell>
              <TableCell className={classes.titleTable}>
                <FormattedMessage id="Nit" />{" "}
              </TableCell>
              <TableCell className={classes.titleTable} align="center">
                <FormattedMessage id="State" />{" "}
              </TableCell>
              <TableCell className={classes.titleTable} align="center">
                <FormattedMessage id="Actions" />{" "}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0 ? entities?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : entities
            )?.map((row) => (
              <EntitiesBody key={row.nit} entity={row} />)
            )}
          </TableBody>
          {/* --------- Footer para paginación -------- */}
          <CustomizedTableFooter count={count} rowsPerPage={rowsPerPage} page={page} />
        </Table>
      </TableContainer>
    </ThemeProvider>
  );
};
